import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-text-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './text-button.component.html',
  styleUrl: './text-button.component.scss'
})
export class TextButtonComponent {
  @Input() mb: string = "0px";
  @Input() mt: string = "0px";
  @Input() minHeight: string = "46px";
  @Input() text: string = "Button";
  @Output() handleClick = new EventEmitter;

  handleBtnClick() {
    this.handleClick.emit();
  }
}
